// extracted by mini-css-extract-plugin
module.exports = {"variable-list":"Variables_variable-list__1lU_r","download-all-button":"Variables_download-all-button__3HjXf"};